import { useLoggedOutCategoryPageCatNavResponse } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";

export const useLoggedOutCategoryPageisLoadedAndHasNoResults = () => {
  const {
    data: { productFirstSearchResults },
    isFetching,
  } = useLoggedOutCategoryPageCatNavResponse();
  return !productFirstSearchResults?.length && !isFetching;
};
